import { createGetDataReducer } from "./CommonReducer";
import { FAQLIST ,FAQCREATE ,FAQSTATUSCHANGES , FAQDETAILS , FAQUPDATE  ,FAQDELETE  } from "../../Constants/FaqConstants";

export const FaqGetReducer = createGetDataReducer( FAQLIST );
export const FaqCreateReducer = createGetDataReducer( FAQCREATE );
export const FaqStatusReducer = createGetDataReducer( FAQSTATUSCHANGES );
export const FaqUpdateReducer = createGetDataReducer( FAQUPDATE );
export const FaqDetailsReducer = createGetDataReducer( FAQDETAILS );
export const FaqDeleteReducer = createGetDataReducer( FAQDELETE );








